
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Layout from '../Home'
import DoctorTypeTable from '../../components/DoctorTypeTable'
import { TABLE_TYPES } from '../../constant'

@inject('DoctorTypes')
@observer
class index extends Component {
  state = {
    data: []
  }

  async componentDidMount() {
    const { DoctorTypes } = this.props
    await DoctorTypes.fetchDoctorTypes()
    this.setState({ data: DoctorTypes.getDoctorTypes })
  }

  handleDelete = async id => {
    //  const { DoctorTypes } = this.props
    //  await DoctorTypes.deleteDoctorTypes(id)
    //  this.setState({ data: DoctorTypes.getDoctorTypes })
  }

  render() {
    const { data } = this.state

    return (
      <Layout
        {...this.props}
        render={(props) => (
          <DoctorTypeTable
            {...props}
            data={data}
            handleDelete={this.handleDelete}
            tableType={TABLE_TYPES.doctorTypes}
            style={{ width: '100%' }}
          />
        )}
      />
    )
  }
}

export default index
